import { Hash } from "viem";
import { useTokenListByChain } from "../../../hooks/useTokenListByChain";
import React, { useState } from "react";
import { getTokenIcon } from "../../../utils/tokenIconUtils";
import { SkeletonCircle } from "../../general/Skeleton";

export const TokenRowIcon = ({
  tokenAddress,
  isLoading,
  size = 28,
}: {
  tokenAddress: Hash;
  isLoading: boolean;
  size?: number;
}) => {
  const tokenList = useTokenListByChain();
  const [imageLoaded, setImageLoaded] = useState<boolean>(false);
  const showImage = !isLoading && imageLoaded;
  const iconUrl = getTokenIcon(tokenAddress, tokenList);

  const IconSkeleton = () => (
    <SkeletonCircle
      style={showImage ? { display: "none" } : undefined}
      isVisible={!showImage}
      width={showImage ? 0 : 28}
      height={showImage ? 0 : 28}
    />
  );

  if (tokenList == null) {
    return <IconSkeleton />;
  }

  if (iconUrl == null) {
    return null;
  }

  return (
    <>
      <img
        src={iconUrl}
        onLoad={() => setImageLoaded(true)}
        alt={`${tokenAddress} icon`}
        style={{
          ...(showImage ? {} : { display: "none" }),
          width: size,
          height: size,
          borderRadius: "50%",
        }}
      />
      <IconSkeleton />
    </>
  );
};
